const payment = () => {
  //
};

export default payment;
